<template>
	<div
		v-if="rating"
		class="location-box__rating"
	>
		<div class="location-box__rating-logo">
			<img
				class="location-box__rating-logo-image"
				:src="themeImagePath('google-logo.svg')"
				alt="Google"
			/>
		</div>
		<div class="location-box__rating-content">
			<div class="location-box__rating-stars">
				<div class="location-box__rating-stars-back">
					<SVGStarFilled
						v-for="i in stars.max"
						:key="i"
					/>
				</div>
				<div class="location-box__rating-stars-front">
					<SVGStarFilled
						v-for="i in stars.full"
						:key="i"
					/>
					<SVGStarFilledHalf
						v-if="stars.half"
					/>
				</div>
			</div>
			<div class="location-box__rating-info">
				<span
					class="location-box__rating-number-value"
					v-html="rating"
				/>
				<span
					class="location-box__rating-number-label"
					v-html="$tc('locations.rating.starsLabel', rating)"
				/>
				<span
					class="location-box__rating-count-value"
					v-html="ratingsTotal"
				/>
				<span
					class="location-box__rating-count-label"
					v-html="$tc('locations.rating.countLabel', ratingsTotal)"
				/>
			</div>
		</div>
	</div>

</template>

<script>
import { Loader } from "@googlemaps/js-api-loader"

export default {
	data() {
		return {
			googleMapsUrl: this.$root.options.googleMapsUrl,
			googleMapsApiKey: this.$root.options.googleMapsApiKey ?? this.themeValue('THEME_GOOGLE_MAPS_API_KEY'),
			rating: null,
			ratingsTotal: null,
		};
	},
	computed: {
		stars() {
			const rating = Math.round(this.rating * 2) / 2;
			const full = Math.floor(rating);
			const half = Math.round(Math.round((rating - full) * 2) / 2);
			const max = Math.max(5, this.rating || 0);

			return {
				full,
				half,
				max
			}
		}
	},
	methods: {
		async getReviewInformation() {
			try {
				const url = this.googleMapsUrl
					.replace('https://www.google.ch/maps/place/', '')
					.replace('https://www.google.ch/maps/search/', '');

				const [ searchString, coords ] = url.split('/');
				const [ lat, lng ] = coords.replace('@', '').split(',');

				const loader = new Loader({
					apiKey: this.googleMapsApiKey,
					version: "weekly",
				});

				const { PlacesService } = await loader.importLibrary("places");
				const service = new PlacesService(document.createElement('div'));
				const request = {
					query: decodeURIComponent(searchString).replace(/\+/g, ' '),
					fields: ["name", "rating", "user_ratings_total"],
					locationBias: {lat: +lat, lng: +lng}
				};
				service.findPlaceFromQuery(request, (results) => {
					if (results?.length) {
						this.rating = results[0].rating;
						this.ratingsTotal= results[0].user_ratings_total;
					}
				});
			}
			catch {}
		},
	},
	mounted() {
		this.getReviewInformation()
	}
}
</script>

<style>

</style>
